import type {FC} from 'react';
import clsx from 'clsx';
import Image from 'next/image';

import {Container} from '@/modules/foundation/components/container';
import {Link} from '@/modules/foundation/components/link';
import {createPhoneLink, formatPhoneNumber} from '@/modules/foundation/shared/format';
import miljoFyrtarn from '@/public/images/miljofyrtarn.png';

type Address = {
	streetName?: string;
	postalCode?: string;
	city?: string;
};

export type FooterProps = {
	orgName?: string;
	address?: Address;
	phoneNumber?: string;
	email?: string;
};

export const Footer: FC<FooterProps> = ({orgName, address, phoneNumber, email}) => {
	return (
		<Container as="footer" className={clsx('bg-lysgronn-industri', 'text-gray-800')}>
			<div className="py-8">
				<ul
					className={clsx(
						'flex',
						'flex-wrap',
						'text-center',
						'items-center',
						'justify-center',
						'divide-x',
						'divide-black',
						'[&>li]:px-3',
						'leading-none',
						'gap-y-2',
					)}
				>
					{orgName && <li>{orgName}</li>}

					{address && (
						<li>
							{address.streetName}, {address.postalCode} {address.city}
						</li>
					)}

					{phoneNumber && (
						<li>
							<Link
								href={createPhoneLink(phoneNumber)}
								className={clsx('no-underline', 'hover:underline')}
							>
								Tlf.: {formatPhoneNumber(phoneNumber)}
							</Link>
						</li>
					)}

					{email && (
						<li>
							<Link
								href={`mailto:${email.replaceAll(' ', '')}`}
								className={clsx(
									'font-bold',
									'text-bla-industri',
									'no-underline',
									'hover:underline',
								)}
							>
								{email}
							</Link>
						</li>
					)}

					<li>
						<Link
							href="/informasjonskapsler"
							className={clsx(
								'font-bold',
								'text-bla-industri',
								'no-underline',
								'hover:underline',
							)}
						>
							Informasjonskapsler
						</Link>
					</li>

					<li>
						<a href="https://www.miljofyrtarn.no/" rel="noreferrer" target="_blank">
							<Image src={miljoFyrtarn} alt="" width={80} />
						</a>
					</li>
				</ul>
			</div>
		</Container>
	);
};
